import ol from "openlayers";
import { message } from "antd";

// change layer
export function checkEnableMapLayer(self) {
  let arrChecked = self.props.isEnableLayer;
  let increaseLayer = [];
  let decreaseLayer = [];

  // -----enable layer-----
  self.state.CheckedLayerKeys.forEach((item) => {
    if (!arrChecked.includes(item)) decreaseLayer.push(item);
  });

  decreaseLayer.forEach((item) => {
    if (self.BaseLayer[`${item}`]) {
      self.BaseLayer[`${item}`].setVisible(false);
    }
  });

  // -----disable layer-----
  arrChecked.forEach((item) => {
    if (!self.state.CheckedLayerKeys.includes(item)) increaseLayer.push(item);
  });

  increaseLayer.forEach((item) => {
    if (self.BaseLayer[`${item}`]) {
      self.BaseLayer[`${item}`].setVisible(true);
    }
  });
  //---------=====----------

  self.setState({
    CheckedLayerKeys: arrChecked,
  });
}

// download map
export function onDownloadMap() {
  let mapDiv = document.querySelectorAll(".map.map-div canvas")[0];
  var dataURLtoBlob = function (dataurl) {
    var parts = dataurl.split(","),
      mime = parts[0].match(/:(.*?);/)[1];
    if (parts[0].indexOf("base64") !== -1) {
      var bstr = atob(parts[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }

      return new Blob([u8arr], { type: mime });
    } else {
      var raw = decodeURIComponent(parts[1]);
      return new Blob([raw], { type: mime });
    }
  };
  // must be called in a click handler or some other user action
  var element = document.createElement("a");

  var dataBlob = dataURLtoBlob(mapDiv.toDataURL());

  element.setAttribute("href", URL.createObjectURL(dataBlob));
  element.setAttribute("download", "map.png");

  element.style.display = "none";
  document.body.appendChild(element);

  element.click();

  var clickHandler;
  element.addEventListener(
    "click",
    (clickHandler = function () {
      // ..and to wait a frame
      requestAnimationFrame(function () {
        URL.revokeObjectURL(element.href);
      });

      element.removeAttribute("href");
      element.removeEventListener("click", clickHandler);
    })
  );
  document.body.removeChild(element);
}

export function getMyLocation(self) {
  const location = window.navigator && window.navigator.geolocation;
  if (location) {
    location.getCurrentPosition(
      (position) => {
        let data = {
          toaDoX: position.coords.longitude,
          toaDoY: position.coords.latitude,
          myLocation: true,
        };
        // self.jumpToLocation(data);
        let oo = ol.proj.transform(
          [parseFloat(data.toaDoX), parseFloat(data.toaDoY)],
          "EPSG:4326",
          "EPSG:3857"
        );
        self.setLocation(oo, 19);
      },
      (error) => {
        message.error("Không thể xác định vị trí");
      },
      {
        enableHighAccuracy: true,
        timeout: 5000,
        maximumAge: Infinity,
      }
    );
  }
}

// ban do giay

export function changeBanDoGiay500(value, self, notShowBanDoSo = false) {
  let listLayerDisable500 = [
    "RanhGioiDiaChinh",
    "ThongTinDiaChinh",
    "RanhGioiHanhChinh",
    "BanDo64",
    "BienSoNha",
    "QHCT_Polygon",
    "QHCT_Line",
    "QHPK_Polygon",
    "QHPK_Line",
    "QHPK_RanhGioi",
    "QHC_Polygon",
    "QHC_Line",
    "QHC_RanhGioi",
    "QHC_RanhGioiQuyHoach",
    "KienTruc",
    "QHC_HienTrang",
    'QHC_Test'
  ];
  self.setState({
    BDGiay_500: value,
    BDGiay_5000: false,
    BDGiay_10000: false,
    checkedBanDoGiay: value,
    isShowInfoPopup: false,
  });
  if (self._imgLayer) {
    self._imgLayer.setSource(undefined);
  }
  if (value) {
    self.props.disableMapLayer(true);
    listLayerDisable500.forEach((e) => {
      if (self.BaseLayer[`${e}`]) {
        self.BaseLayer[`${e}`].setVisible(false);
      }
    });
    if (self.BaseLayer.QHCT_RanhGioi) {
      self.BaseLayer.QHCT_RanhGioi.setVisible(true);
    }
  } else {
    if (self.BaseLayer.QHCT_RanhGioi) {
      self.BaseLayer.QHCT_RanhGioi.setVisible(false);
    }
    self.props.disableMapLayer(false);
    if(!notShowBanDoSo) {self.state.CheckedLayerKeys.forEach((e) => {
      self.BaseLayer[`${e}`].setVisible(true);
    });}
  }
}

export function changeBanDoGiay5000(value, self, notShowBanDoSo = false) {
  let listLayerDisable5000 = [
    "RanhGioiDiaChinh",
    "ThongTinDiaChinh",
    "RanhGioiHanhChinh",
    "BanDo64",
    "BienSoNha",
    "QHCT_Polygon",
    "QHCT_Line",
    "QHCT_RanhGioi",
    "QHPK_Polygon",
    "QHPK_Line",
    "QHC_Polygon",
    "QHC_RanhGioi",
    "QHC_Line",
    "QHC_RanhGioiQuyHoach",
    "KienTruc",
    "QHC_HienTrang",
    'QHC_Test'
  ];

  self.setState({
    BDGiay_5000: value,
    BDGiay_500: false,
    BDGiay_10000: false,
    checkedBanDoGiay: value,
    isShowInfoPopup: false,
  });

  if (self._imgLayer) {
    self._imgLayer.setSource(undefined);
  }

  if (value) {
    self.props.disableMapLayer(true);
    listLayerDisable5000.forEach((e) => {
      if (self.BaseLayer[`${e}`]) {
        self.BaseLayer[`${e}`].setVisible(false);
      }
    });
    if (self.BaseLayer.QHPK_RanhGioi) {
      self.BaseLayer.QHPK_RanhGioi.setVisible(true);
    }
  } else {
    if (self.BaseLayer.QHPK_RanhGioi) {
      self.BaseLayer.QHPK_RanhGioi.setVisible(false);
    }
    self.props.disableMapLayer(false);
    if(!notShowBanDoSo) {self.state.CheckedLayerKeys.forEach((e) => {
      self.BaseLayer[`${e}`].setVisible(true);
    });}
  }
}

export function changeBanDoGiay10000(value, self, notShowBanDoSo = false) {
  let listLayerDisable10000 = [
    "RanhGioiDiaChinh",
    "ThongTinDiaChinh",
    "RanhGioiHanhChinh",
    "BanDo64",
    "BienSoNha",
    "QHCT_Polygon",
    "QHCT_Line",
    "QHCT_RanhGioi",
    "QHPK_Polygon",
    "QHPK_Line",
    "QHPK_RanhGioi",
    "QHC_Polygon",
    "QHC_Line",
    "QHC_RanhGioiQuyHoach",
    "QHC_HienTrang",
    "KienTruc",
    'QHC_Test'
  ];

  self.setState({
    BDGiay_5000: false,
    BDGiay_500: false,
    BDGiay_10000: value,
    checkedBanDoGiay: value,
    isShowInfoPopup: false,
  });

  if (self._imgLayer) {
    self._imgLayer.setSource(undefined);
  }

  if (value) {
    self.props.disableMapLayer(true);
    listLayerDisable10000.forEach((e) => {
      if (self.BaseLayer[`${e}`]) {
        self.BaseLayer[`${e}`].setVisible(false);
      }
    });
    self.BaseLayer.QHC_RanhGioi.setVisible(true);
  } else {
    self.BaseLayer.QHC_RanhGioi.setVisible(false);
    self.props.disableMapLayer(false);
    if(!notShowBanDoSo) {self.state.CheckedLayerKeys.forEach((e) => {
      self.BaseLayer[`${e}`].setVisible(true);
    });}
  }
}
